<template>
  <modal @close="$emit('close')">
    <template #body>
      <div class="modal-write">
        <div class="modal-write__form">
          <div class="modal-write__title">Рассчитать проект</div>
          <div class="modal-write__info">
            Опишите задачу — дизайнер свяжется с вами в день обращения
          </div>

          <form @submit.prevent="send" novalidate>
            <div class="modal-write__inputs-row">
              <Input
                placeholder="Ваше имя"
                type="text"
                class="input input-full"
                v-model="name"
              />
              <Input
                placeholder="Ваш телефон"
                type="text"
                class="input input-full"
                v-model="phone"
              />
            </div>

            <div class="modal-write__input-box">
              <Textarea
                placeholder="Площадь, тип помещения, пожелания по материалам и стилю"
                class="input input-full"
                v-model="comment"
              />
            </div>

            <div class="modal-write__input-box">
              <label class="fp-file">
                <input
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png,.pdf,.dwg"
                  class="fp-file__input"
                  @change="onFilePick"
                />
                <span class="fp-file__label">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                    <polyline points="17 8 12 3 7 8"/>
                    <line x1="12" y1="3" x2="12" y2="15"/>
                  </svg>
                  <span v-if="!files.length">Прикрепить план, фото или референсы</span>
                  <span v-else>{{ files.map(f => f.name).join(', ') }}</span>
                </span>
              </label>
              <p class="fp-file__hint">JPG, PNG, PDF, DWG — до 20 МБ каждый</p>
            </div>

            <button
              type="submit"
              class="full-dark-btn fp-submit"
              :disabled="!agreed"
            >Отправить запрос</button>

            <Checkbox
              label="Я соглашаюсь с <a href='/privacy'>политикой конфиденциальности</a>"
              :isCheck="agreed"
              name="agreement_politic"
              @change="agreed = $event"
            />
          </form>

          <p v-if="success" class="fp-success">Запрос отправлен. Дизайнер свяжется с вами в течение дня.</p>
          <p v-if="error" class="fp-error">{{ error }}</p>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import modal from '~/components/UI/Modal.vue'
import Input from '~/components/UI/inputs/Input.vue'
import Textarea from '~/components/UI/inputs/Textarea.vue'
import Checkbox from '~/components/UI/btn/Checkbox.vue'
import api from '~/api/api.js'

defineEmits(['close'])

const name    = ref('')
const phone   = ref('')
const comment = ref('')
const files   = ref([])
const agreed  = ref(false)
const success = ref(false)
const error   = ref('')

function onFilePick(e) {
  files.value = Array.from(e.target.files || []).slice(0, 10)
}

async function send() {
  error.value = ''
  if (!name.value || !phone.value) {
    error.value = 'Заполните имя и телефон.'
    return
  }
  if (!agreed.value) {
    error.value = 'Подтвердите согласие.'
    return
  }

  const fd = new FormData()
  fd.append('product_id', '44')
  fd.append('name', name.value)
  fd.append('phone', phone.value)
  if (comment.value) fd.append('comment', comment.value)
  files.value.forEach(f => fd.append('files[]', f))

  try {
    await api('/order', fd, 'POST')
    success.value = true
    name.value  = ''
    phone.value = ''
    comment.value = ''
    files.value = []
  } catch {
    error.value = 'Произошла ошибка. Попробуйте ещё раз.'
  }
}
</script>

<style scoped lang="scss">
.fp-file {
  display: block;
  cursor: pointer;

  &__input { display: none; }

  &__label {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.4rem 1.6rem;
    border: 1px solid #d8d8d8;
    border-radius: 0.4rem;
    font-size: 1.5rem;
    color: #555;
    background: #fff;
    transition: border-color 0.2s;
    cursor: pointer;

    &:hover { border-color: #1B1918; }

    svg { flex-shrink: 0; color: #aaa; }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &__hint {
    margin-top: 0.6rem;
    font-size: 1.2rem;
    color: #aaa;
  }
}

.fp-success {
  margin-top: 1.6rem;
  font-size: 1.4rem;
  color: #2e7d32;
}

.fp-error {
  margin-top: 1.2rem;
  font-size: 1.4rem;
  color: #c62828;
}
</style>
